








































































































































import { Component, Vue } from 'vue-property-decorator'
import { getNoticeList, deleteNotice } from '@/api/notice'
import { setNoticeStatusByStatus } from '@/api/notice'

@Component({
  name: 'NoticeManage'
})
export default class NoticeManage extends Vue {
  private input = ''
  private counts = 0
  private page = 1
  private pageSize = 10
  private tableData = []
  private checkList = []
  private status = ''

  created() {
    this.init()

    // 监听路由参数，处理从编辑页返回的刷新请求
    if (this.$route.query.refresh === 'true') {
      this.init(true)
    }
  }

  private async init(forceRefresh = false) {
    const params = {
      page: this.page,
      pageSize: this.pageSize,
      title: this.input || undefined,
      status: this.status,
      _t: forceRefresh ? new Date().getTime() : undefined
    }
    await getNoticeList(params)
      .then(res => {
        if (res && res.data && res.data.code === 1) {
          this.tableData = res.data.data.records || []
          this.counts = Number(res.data.data.total)
        } else {
          this.$message.error(res.data.msg || '操作失败')
        }
      })
      .catch(err => {
        this.$message.error('请求出错了：' + err.message)
      })
  }

  private handleQuery() {
    this.page = 1
    this.init()
  }

  private addNoticeHandle(st: any) {
    if (st === 'add') {
      this.$router.push({ path: '/notice/add' })
    } else {
      this.$router.push({ path: '/notice/add', query: { id: st.id } })
    }
  }

  private viewDetail(row: any) {
    this.$router.push({ path: '/notice/detail', query: { id: row.id } })
  }

  private deleteHandle(type: string, id: any) {
    if (type === '批量' && id === null) {
      if (this.checkList.length === 0) {
        return this.$message.error('请选择删除对象')
      }
    }
    this.$confirm('确定删除该公告?', '确定删除', {
      confirmButtonText: '删除',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      deleteNotice(type === '批量' ? this.checkList.join(',') : id)
        .then(res => {
          if (res.data.code === 1) {
            this.$message.success('删除成功！')
            this.init()
          } else {
            this.$message.error(res.data.msg || '删除失败')
          }
        })
        .catch(err => {
          this.$message.error('请求出错了：' + err.message)
        })
    })
  }

  private statusHandle(status: string) {
    // 已移除批量启用/禁用功能
  }

  private handleSelectionChange(val: any) {
    let checkArr: string[] = []
    val.forEach((n: any) => {
      checkArr.push(n.id)
    })
    this.checkList = checkArr
  }

  private handleSizeChange(val: any) {
    this.pageSize = val
    this.init()
  }

  private handleCurrentChange(val: any) {
    this.page = val
    this.init()
  }
}
